import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from 'react-select';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js';
const PharmRFQEntry = () => {
    const [prs, setPrs] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [rfqData, setRfqData] = useState({
        pr: '',
        vendors: []
    });
    useEffect(() => {
        fetchPR();
        fetchVendors();
    }, []);
    const fetchPR = () => {
        axios
            .get(`${baseUrl}pharm-purchase-request-search/`)
            .then(res => setPrs(res.data));
    };
    const fetchVendors = () => {
        axios
            .get(`${baseUrl}add-distributor/`)
            .then(res => setVendors(res.data));
    };
    // React Select Change
    const handleVendorChange = (selectedOptions) => {
        const vendorIds = selectedOptions
            ? selectedOptions.map(item => item.value)
            : [];
        setRfqData({
            ...rfqData,
            vendors: vendorIds
        });
    };
    const formSubmit = () => {
        if (!rfqData.pr) {
            Swal.fire(
                'Error',
                'Please select Purchase Request',
                'error'
            );
            return;
        }
        if (rfqData.vendors.length === 0) {
            Swal.fire(
                'Error',
                'Please select atleast one vendor',
                'error'
            );
            return;
        }
        axios.post(`${baseUrl}get-pharm-rfq-no/`)
            .then(response => {
                const rfq_no = response.data.value;
                const _formData = new FormData();
                _formData.append('pr', rfqData.pr);
                _formData.append('rfq_no', rfq_no);
                _formData.append('status', 'Open');
                _formData.append('addedby', userName);
                _formData.append('location', userLocation);
                _formData.append('ip_add', ipAddress);
                axios.post(`${baseUrl}pharm-rfq/`, _formData)
                    .then(res => {
                        const rfqId = res.data.id;
                        // Save Vendors
                        const vendorPromises = rfqData.vendors.map((vendor) => {
                            const vendorData = new FormData();
                            vendorData.append('rfq', rfqId);
                            vendorData.append('vendor', vendor);
                            vendorData.append('addedby', userName);
                            vendorData.append('location', userLocation);
                            vendorData.append('ip_add', ipAddress);
                            return axios.post(
                                `${baseUrl}pharm-rfq-vendor/`,
                                vendorData
                            );
                        });
                        Promise.all(vendorPromises)
                            .then(() => {
                                Swal.fire(
                                    'Success',
                                    `RFQ Created Successfully : ${rfq_no}`,
                                    'success'
                                );
                                setTimeout(() => {
                                    window.location.href = '/pharm-rfq-ent-list';
                                }, 2000);
                            });
                    })
                    .catch(err => {
                        console.log(err.response?.data);
                        Swal.fire(
                            'Error',
                            'Failed to create RFQ',
                            'error'
                        );
                    });
            })
            .catch(err => {
                console.log(err);
                Swal.fire(
                    'Error',
                    'Failed to generate RFQ Number',
                    'error'
                );
            });
    };
    // Convert Vendors for React Select
    const vendorOptions = vendors.map(item => ({
        value: item.id,
        label: item.name
    }));
    return (
        <section className='container mt-4'>

            <h3>RFQ Entry</h3>

            <div className='row'>

                {/* Purchase Request */}
                <div className='col-md-6 mb-3'>

                    <label>Purchase Request</label>

                    <select
                        className='form-control'
                        value={rfqData.pr}
                        onChange={(e) =>
                            setRfqData({
                                ...rfqData,
                                pr: e.target.value
                            })
                        }
                    >

                        <option value=''>
                            Select PR
                        </option>

                        {prs.map((item, index) => (
                            <option
                                key={index}
                                value={item.id}
                            >
                                {item.pr_no}
                            </option>
                        ))}

                    </select>

                </div>

                {/* Vendors */}
                <div className='col-md-6 mb-3'>

                    <label>Vendors</label>

                    <Select
                        options={vendorOptions}
                        isMulti
                        isSearchable
                        placeholder="Search & Select Vendors"
                        onChange={handleVendorChange}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '45px'
                            })
                        }}
                    />

                </div>

            </div>

            <button
                className='btn btn-primary'
                onClick={formSubmit}
            >
                Create RFQ
            </button>

        </section>
    );
};
export default PharmRFQEntry;